import { useState, useEffect } from 'react'
import Icon from 'core/assets/icons'

type TImage = {
  src?: string;
  alt: string;
  className?: string;
}

const Image = ({
  src = '',
  alt,
  className,
  ...rest
}: TImage) => {
  const [imgSrc, setImgSrc] = useState<string>(src);
  const [hasError, setHasError] = useState<boolean>(false);

  // Reset imgSrc when src prop changes
  useEffect(() => {
    if (src) {
      setImgSrc(src);
      setHasError(false);
    }else{
      setImgSrc(Icon.NoImage);
    }
  }, [src, alt]);

  const handleError = () => {
    if (!hasError) {
      setImgSrc(Icon.NoImage);
      setHasError(true);
    }
  };

  const handleLoad = () => {};

  return <img
    src={imgSrc}
    alt={alt}
    className={className}
    onError={handleError}
    onLoad={handleLoad}
    {...rest}
  />
}

export default Image
